import React from 'react';
import { motion } from 'framer-motion';

const AccountPopup = ({ onClose, onSignIn, onCreateAccount }) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        >
            <motion.div
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0.9 }}
                className="bg-white p-6 rounded-lg shadow-lg"
            >
                <h2 className="text-2xl font-bold mb-4">Account Options</h2>
                <button
                    onClick={onSignIn}
                    className="w-full bg-orange-500 text-white py-2 rounded mb-2"
                >
                    Sign In
                </button>
                <button
                    onClick={onCreateAccount}
                    className="w-full bg-orange-400 text-white py-2 rounded mb-4"
                >
                    Create Account
                </button>
                <button
                    onClick={onClose}
                    className="w-full bg-gray-300 text-gray-800 py-2 rounded"
                >
                    Close
                </button>
            </motion.div>
        </motion.div>
    );
};

export default AccountPopup;